/**
 * Hero photo layouts, shared by the hero `<img>` tags and the build step that
 * writes the `/gaia` preload, so the browser picks the same file for both.
 */
export const HERO_LAYOUTS = {
  scrollStory: {
    media: "(min-width: 1024px) and (orientation: landscape)",
    sizes: "100vw",
  },
  // Phones cover-crop the landscape photo into an 80svh-tall card, so it
  // renders about 107vh wide.
  stacked: {
    media: "(max-width: 1023px), (orientation: portrait)",
    sizes: "(min-width: 640px) 100vw, 107vh",
  },
};
